import React from 'react';
import { GlobalLogic } from '../../shared/logic/global-logic';
import { TestLogic, IDirection } from '../logic/test-logic';
import { Landolt } from '../views/landolt';
import { EyeTestInput } from '../views/eye-test-input';
import '../styles/eye-test.scss';

interface Props {
	landoltDirection: number;
	landoltBaseSize: number;
	landoltColor: string;
	onDirectionInput: (direction: IDirection) => void;

}

export class EyeTestInputController extends React.PureComponent<Props> {
	private _globalLogic = GlobalLogic.getInstance();

	componentDidMount(): void {
		document.addEventListener('keydown', this.handleKeyEvent);
	}

	componentWillUnmount(): void {
		document.removeEventListener('keydown', this.handleKeyEvent);
	}

	handleKeyEvent = (key: any): void => {
		if (isNaN(+key.key) || +key.key === 0) {
			return;
		}
		this.props.onDirectionInput(TestLogic.getDirectionByKeypadNum(+key.key));
	};

	handlePress = (direction: IDirection): void => {
		this.props.onDirectionInput(direction);
	};

	render(): any {
		return (
			<>
				<EyeTestInput onInput={this.handlePress}>
					<Landolt
						direction={this.props.landoltDirection}
						baseSize={this.props.landoltBaseSize}
						scaleFactor={this._globalLogic.scaleFactor}
						fontColor={this.props.landoltColor}
					/>
				</EyeTestInput>
			</>
		);
	}
}
